import { IComboBox, IComboBoxOption } from "@fluentui/react";
import { useRef, useState } from "react";

const UseComboNivel = () => {
    const [dataComboNivel, setDataComboRazon] = useState<IComboBoxOption[]>(
        [
            { key: 1, text: 'Tajos' },
            { key: 2, text: 'Regiones' },
            { key: 3, text: 'Ubicaciones' },
        ]
    );

    const comboBoxRefNivel = useRef<IComboBox>(null);
    const onClickComboNivel = () => comboBoxRefNivel.current?.focus(true);

    return {
        dataComboNivel,
        onClickComboNivel,
        comboBoxRefNivel
    }
}
export { UseComboNivel }